export default function valIsNull(val) {
  return (
    val === null ||
    val === undefined ||
    (typeof val === 'string' && val === '')
  );
}
